import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslationObject,
} from '@ngx-translate/core';
import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { AppEnvironment } from 'sham-components/services';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { appEnvFactory } from './services/appEnvFactory';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';
import { authInterceptor } from './services/auth.interceptor';
import { AuthService } from './services/auth.service';

class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}
  getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`/assets/i18n/${lang}.json`);
  }
}

export function httpLoaderFactory(http: HttpClient) {
  return new CustomTranslateLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
    provideAppInitializer(() => {
      const appEnv = inject(AppEnvironment);
      const authService = inject(AuthService);
      const dashboardService = inject(ShamDashboardData);
      const translationService = inject(TranslateService);

      return appEnvFactory(appEnv).then(() =>
        Promise.allSettled([
          firstValueFrom(authService.processRefreshVerification()),
          dashboardLayoutDataFactory(dashboardService, translationService),
        ]),
      );
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
